import restful from '../vuex'
import axios from 'axios'

const state = {
  ...restful.states('wechat_config')
}

const getters = {
  ...restful.getters('wechat_config')
}

const actions = {
  ...restful.actions('wechat_configs'),
  async find_one ({ commit }) {
    const res = await axios.get('wechat_configs/find_one')
    commit('wechat_config', res.data)
  }
}

const mutations = {
  ...restful.mutations('wechat_config'),
  wechat_config (state, wechat_config) {
    state.wechat_config = wechat_config
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
